import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

export default function BroadcastCardApproved({ baseUrl, onLoginSuccess, currentUser }) {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const session_id = searchParams.get("session_id");

        var formData = new FormData();

        formData.append("session_id", session_id);

        if (currentUser) formData.append("token", currentUser.token);

        axios.post(baseUrl + "/successBroadcastCheckoutpayment_customer", formData)
            .then(response => {
                console.log("Login success:", response.data);

                const channel = new BroadcastChannel("chamcore-broadcast-approve-payment");
                channel.postMessage({
                    type: "BROADCAST_CARD_PAYMENT_APPROVED",
                    token: response.data.token,
                    role: response.data.role,
                    name: response.data.name,
                });


                // Optionally close tab automatically
                // wait for message delivery
                setTimeout(() => {
                    channel.close();
                    window.close();
                }, 1000);
            })
    }, [searchParams]);

    return (
        <div className="p-6 text-center">
            <h1 className="text-xl font-bold">Vellykket betaling</h1>
            <p>Betalingen for timebestillingen er vellykket.</p>
        </div>
    );
}
